export default "__VITE_ASSET__DYzIjaRs__"